import { API_ENDPOINTS } from '../constants/api';
import apiClient from '../config/axiosInterceptors';
import { ResponseHandler } from '../config/responseHandler';

class CategoryService {
  /**
   * Fetch all categories with subcategories
   * @returns {Promise<Object>} Response data containing categories and subcategories
   */
  async getAllCategoriesWithSub() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ALL_CATEGORIES_WITH_SUB);
      return ResponseHandler.handleSuccess(response);
    } catch (error) {
      return ResponseHandler.handleError(error);
    }
  }

  /**
   * Fetch all categories
   * @returns {Promise<Object>} Response data containing categories
   */
  async getAllCategories() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ALL_CATEGORIES);
      return ResponseHandler.handleSuccess(response);
    } catch (error) {
      return ResponseHandler.handleError(error);
    }
  }

  /**
   * Fetch categories with creator count
   * @param {boolean} isGuest - Whether the request is from a guest user
   * @returns {Promise<Object>} Response data containing categories with creator counts
   */
  async getCategoriesWithCount(isGuest = false) {
    try {
      const config = isGuest ? { skipAuth: true } : {};
      const response = await apiClient.get(API_ENDPOINTS.CATEGORIES_WITH_COUNT, config);
      return ResponseHandler.handleSuccess(response);
    } catch (error) {
      return ResponseHandler.handleError(error);
    }
  }

  /**
   * Fetch category creators list with search and filters
   * @param {Object} params - Query parameters
   * @param {string} params.search - Search query string
   * @param {number} params.limit - Number of results to fetch
   * @param {string} params.userId - User ID
   * @returns {Promise<Object>} Response data containing category creators list
   */
  async getCategoryCreatorsList(params = {}) {
    try {
      const {
        search = '',
        limit = 10,
        userId = null
      } = params;

      // Build query params object
      const queryParamsObj = {};

      if (limit) {
        queryParamsObj.limit = limit.toString();
      }

      if (search && search.trim()) {
        queryParamsObj.search = encodeURIComponent(search.trim());
      }

      if (userId) {
        queryParamsObj.userId = userId;
      }

      const queryParams = new URLSearchParams(queryParamsObj);
      const endpoint = `${API_ENDPOINTS.CATEGORY_CREATORS_LIST}?${queryParams}`;

      const response = await apiClient.get(endpoint);
      return ResponseHandler.handleSuccess(response);
    } catch (error) {
      return ResponseHandler.handleError(error);
    }
  }
}

export default new CategoryService();
